import { MAC_VOICE_SCRIPT } from './macVoicePage';

// Reuse the actual audio/WebRTC engine. Only its host message transport changes.
// This page receives SDP and bounded audio-event commands, never account tokens.
export const WINDOWS_VOICE_SCRIPT = MAC_VOICE_SCRIPT.replace(
  'window.webkit.messageHandlers.voice.postMessage(event)',
  "window.chrome.webview.postMessage(JSON.stringify({ kind: 'event', event }))",
) + String.raw`
window.chrome.webview.addEventListener('message', async ({ data }) => {
  try {
    const value = await window.macVoice.command(data.command, data.payload || {});
    window.chrome.webview.postMessage(JSON.stringify({ kind: 'result', request: data.request, value }));
  } catch (error) {
    window.chrome.webview.postMessage(JSON.stringify({ kind: 'result', request: data.request, error: error.message || 'Voice command failed' }));
  }
});
window.chrome.webview.postMessage(JSON.stringify({ kind: 'ready' }));
`;

export const WINDOWS_VOICE_HTML = `<!doctype html><html><head><meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="default-src 'none'; script-src 'unsafe-inline'; connect-src 'none'; media-src blob:; frame-src 'none'; base-uri 'none'; form-action 'none'"></head><body><script>${WINDOWS_VOICE_SCRIPT}</script></body></html>`;
